import { createNamespacedHelpers } from 'vuex';
import _ from 'lodash';

const { mapActions, mapGetters } = createNamespacedHelpers('user');

export default {
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'jwt',
      'customer',
      'orders',
      'order',
      'incadeaOrders',
      'shoppingList',
    ]),
  },
  methods: {
    getAddressById(id) {
      return _.find(this.customer.Addresses, (address) => address.Id === id);
    },
    ...mapActions([
      'login',
      'register',
      'forgotPassword',
      'forgotPasswordConfirm',
      'logout',
      'fetchCustomer',
      'fetchCurrentCustomer',
      'updateCustomer',
      'setPassword',
      'addAddress',
      'updateAddress',
      'deleteAddress',
      'fetchOrders',
      'fetchIncadeaOrders',
      'fetchOrder',
      'fetchShoppingList',
      'addShoppingList',
      'deleteShoppingList',
      'creteCartFromShoppingList',
    ]),
  },
};
